/* eslint-disable */
export default {
  conferenceCall: 'Chamada em conferência',
  onHold: 'Em espera',
  ongoing: 'Em andamento',
  unknown: 'Desconhecido',
  disconnected: 'Desconectada',
  loading: 'Carregando...',
  loadingTimeout: 'O carregamento atingiu o tempo limite.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
